<template>
  <div>
    <ion-toast
      :is-open="success_message!=''"
      :message="success_message"
      :duration="4000"
      position="middle"
      color="success"
    >
    </ion-toast>
    <ion-toast
      :is-open="error!=''"
      :message="error"
      :duration="4000"
      position="middle"
      color="danger"
    >
    </ion-toast>
<!--     <ion-text v-if="success_message!=''" style="text-align:center;" color="primary">
      <h2>{{ success_message }}</h2>
    </ion-text>
    <ion-text v-if="error!=''" style="text-align:center;" color="danger">
      <h2>{{ error }}</h2>
    </ion-text> -->
    <!-- <p class="decode-result">Last result: <b>{{ result }}</b></p> -->
    <!-- <qrcode-stream @decode="onDecode" @init="onInit" /> -->
    <StreamBarcodeReader @decode="onDecode" @loaded="onInit"></StreamBarcodeReader>

    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button class="sound_button" size="small" v-on:click="onSound" >Fix Beep</ion-button>
        </ion-col>
        <ion-col>
          <ion-button class="cancel_button" size="small" v-on:click="onCancel" >Done Scanning</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>

  </div>
</template>

<script>
// import { QrcodeStream } from '../../node_modules/vue3-qrcode-reader'
import { IonGrid, IonRow, IonCol, IonButton, IonToast, /* IonText, */ modalController } from '@ionic/vue';

export default {
  props : [ 'title'],
  components: { IonGrid, IonRow, IonCol, IonButton, IonToast /* IonText */ /* QrcodeStream, */  },

  data () {
    return {
      result: '',
      error: '',
      success_message: '',
      modalController: modalController,

      selected_item: {},
      tearsheet_checked: false,
      memo_checked: false,
      quote_checked: false,
      item_notes: '',
      can_scan: true,
      audioOK: new Audio('/app/assets/sounds/beep.mp3'),
      audioError: new Audio('/app/assets/sounds/error.mp3')
    }
  },

  methods: {
    onDecode (result) {
      if(this.title=='New_Visit'){
        if(this.can_scan){
          console.log('onDecode',result);
          this.result = result
          // add item to list
          this.searchForItem(this.result)
        }
      } else {
        console.log('onDecode',result);
        this.result = result
        this.modalController.dismiss(this.result);
      }
    },

    async searchForItem( scanned_code ){

      this.can_scan = false;
      this.error = '';
      this.success_message = '';

      await this.$store.dispatch("visits/item_scan", { code: scanned_code });
      var error = this.$store.getters["visits/getRequestError"];
      console.log("Error: " + error);

      if (error != "") {
        // screen's components variables
        this.error = error;
      } else {
        console.log("Scanned complete");

        var scanResult = this.$store.getters["visits/getItemFromScan"];
        this.selected_item = scanResult.product;

        // Check if the item already exists in the list
        let existing_items = this.$store.getters["visits/getSelectedItems"];
        let item_in_list = false;
        for( let i=0; i<existing_items.length; i++ ){
          if( this.selected_item.master_conn_id==existing_items[i].master_conn_id && this.selected_item.pitem_id==existing_items[i].pitem_id ){
            item_in_list = true;
            this.error = "Item Already Exists"
            // Beep
            this.audioError.play();

            setTimeout(() => {
              this.can_scan = true;
              this.error = '';
            }, 2300);
            break;
          }
        }

        // add item to the list of this visit
        if(!item_in_list)
          this.add_item_to_list();
      }

    },

    async add_item_to_list(){

      var selected_options = "";
      if (this.selected_item.ptype_id==1 || this.selected_item.ptype_id==2 || this.selected_item.ptype_id==5 || this.selected_item.ptype_id==8) {
        selected_options += "[TEARSHEET]";
        // set selections
        this.tearsheet_checked = true;
        this.memo_checked = false;
        this.quote_checked = false;
        this.item_notes = '';
      }
      if (this.selected_item.ptype_id==3 || this.selected_item.ptype_id==4 || this.selected_item.ptype_id==7 || this.selected_item.ptype_id==6) {
        selected_options += "[TEARSHEET][SAMPLE]";
        // set selections
        this.tearsheet_checked = true;
        this.memo_checked = true;
        this.quote_checked = false;
        this.item_notes = '';
      }

      await this.$store.dispatch("visits/visit_add_item", {
        flvis_id: this.$store.getters["visits/getCurrentVisitId"],
        flvisi_type: 0, // product
        pitem_id: this.selected_item.pitem_id,
        inv_id: 0,
        options: selected_options,
        options_details: "",
        flvisi_notes: "",
        conn_id: this.selected_item.master_conn_id
      });
      var error = this.$store.getters["visits/getRequestError"];

      if (error != "") {
        this.success_message = '';
        this.error = error;
        // Beep
        this.audioError.play();

        setTimeout(() => {
          console.log('Error Released');
          this.can_scan = true;
          this.error = '';
        }, 2300);

      } else {

        // Beep
        this.audioOK.play();

        // push to the selected items
        this.selected_item.flvisi_id = this.$store.getters["visits/getInsertedItemId"];
        this.selected_item.tearsheet_checked = this.tearsheet_checked;
        this.selected_item.memo_checked = this.memo_checked;
        this.selected_item.quote_checked = this.quote_checked;
        this.selected_item.item_note = this.item_notes;

        // insert the selected item to the state
        this.$store.commit("visits/insertSelectedItem", this.selected_item);

        this.error = "";
        this.success_message = "Product added successfully!";

        setTimeout(() => {
          console.log('Success Released');
          this.can_scan = true;
          this.success_message = '';
        }, 2000)
      }

    },

    onCancel(){
      this.modalController.dismiss('cancelled');
    },

    onSound(){
      this.audioOK.autoplay = true;
      this.audioError.autoplay = true;
    },

    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permission"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        } else if (error.name === 'InsecureContextError') {
          this.error = 'ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.';
        } else {
          this.error = `ERROR: Camera error (${error.name})`;
        }
      }
    }
  },
  mounted() {
    // this.audioOK.autoplay = true;
    // this.audioError.autoplay = true;
  }
}
</script>

<style scoped>
:root {
    --video-height: 240px;
}
.scanner-container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: var(--video-height);
}
video#scanner {
    max-width: 100%; 
    width: 100% !important;
    height: var(--video-height);
}

  .error {
    font-weight: bold;
    color: red;
    margin:5px;
  }

  .success_message {
    font-weight: bold;
    color: green;
    margin:5px;
  }

  .cancel_button {
    float:right;
  }

</style>
